import React from "react";
import ReactDOM from "react-dom/client";

import { PayPalScriptProvider } from "@paypal/react-paypal-js";

import App from "./App";
import { UserProvider } from "./context/UserContext";
import { FormProvider } from "./context/formRefContext";
import { SubscriptionProvider } from "./context/subscriptionContext";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"; // Make sure this import is correct

import "./i18n";
import reportWebVitals from "./reportWebVitals";

import "./index.scss";


const mode = process.env.REACT_APP_ENV;
const clientId =
  mode === "development"
    ? process.env.REACT_APP_SANDBOX_CLIENT_ID
    : process.env.REACT_APP_LIVE_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PayPalScriptProvider options={{ "client-id": clientId, vault: true }}>
      <FormProvider>
        <UserProvider>
          <SubscriptionProvider>
            <App />
          </SubscriptionProvider>
        </UserProvider>
      </FormProvider>
    </PayPalScriptProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

// This part is correct for index.js
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log('PWA: Update found!', registration);
    if (registration.waiting) {
      console.log('PWA: New SW is waiting, sending SKIP_WAITING message.');
      registration.waiting.postMessage({ type: "SKIP_WAITING" });

      registration.waiting.addEventListener("statechange", () => {
        console.log('PWA: New SW state changed to:', registration.waiting.state);
        if (registration.waiting.state === "activated") {
          console.log('PWA: New SW activated, forcing page reload.');
          window.location.href = window.location.href.split("?")[0] + "?v=" + Date.now();
        }
      });

      setTimeout(() => {
        if (registration.waiting && registration.waiting.state !== "activated") {
          console.warn(
            "PWA: Service Worker activation timeout or event missed. Forcing hard reload as a fallback."
          );
          window.location.reload(true);
        }
      }, 10000);
    }
  },
});


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();